import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

/**
 * App-wide title strategy (WCAG 2.4.2).
 *
 * Sets the document `<title>` on every navigation from the `title` property of
 * the activated route, so screen-reader users get confirmation of where they
 * navigated and browser history/tabs are distinguishable.
 *
 * Add `title: '...'` to route definitions to opt in; routes without a title
 * fall back to the application name.
 */
@Injectable({ providedIn: 'root' })
export class CmTitleStrategy extends TitleStrategy {
  private static readonly APP_NAME = 'Case Manager';

  private readonly _title = inject(Title);

  public override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    this._title.setTitle(
      title ? `${title} · ${CmTitleStrategy.APP_NAME}` : CmTitleStrategy.APP_NAME,
    );
  }
}
